import React, { useState, useContext, useEffect ,useRef } from "react";

import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import Spinner from "../../sample/spinner";
import { Anchor } from "grommet";
import { UserContext } from "../../../context/UserContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import { Redirect } from "react-router";

import PlacesAutocomplete from 'react-places-autocomplete';
const Opportunities = (props) => {
    const context = useContext(UserContext);
    // this.autocompleteInput = React.createRef();
    const autocompleteInput = useRef(null)
    const autocomplete = useState(null)
   
    const [skilllist, setSkilllist] = useState([]);
    const [joblst, setJoblst] = useState([]);
    const [location, setLocation] = useState("");
    // const [newlocation, setNewlocation] = useState("");
    const [newskill, setNewskill] = useState("");
    const [showComponent, setShowComponent] = useState(false);
    const [address, setAddress] = useState("");
   const [loading, setLoading] = useState(false);
  
   const handleChange = (address) => {
    setAddress(address);
  };

  //  const handlePlaceChanged = () =>{
  //   const place = autocomplete.getPlace;
  //   console.log("place = "+ place )
  //    props.onPlaceLoaded(place);
  
  // }


    useEffect(() => {
      // const autocomplete = new google.maps.places.Autocomplete(autocompleteInput.current,
      //   {"types": ["geocode"]});
      //   autocomplete.addListener('place_changed', handlePlaceChanged);
      // Update the document title using the browser API
      getskills();
    }, []);
    const getskills = async () => {
      axios
        .post("LearnerProfile/searchjobOpportunities")
        .then((res) => {
          if (res.data.status === "200") {
           
            setSkilllist(res.data.myskilllist);
           
            return res;
          }
          throw res;
        })
        .catch((error) => {
          // console.log("error123", error);
        });
    };
  
    const sleep =(milliseconds)=> {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    const handleSubmit = e =>{
      e.preventDefault();
      fetchdetails();
     
   }
  
   const fetchdetails=async()=>{
    setLoading(true);
    if (address === "" ) {
      toast.error("Location is mandatory");
      await sleep(3000);
      setLoading(false);
      return;
    } 
    else if (newskill === null  || newskill === "" ) {
      toast.error("Select   Skill  ");
      await sleep(3000);
      setLoading(false);
      return;
    }
      else{
       
         var formData = new FormData();
         formData.append("location", address);
         
        formData.append("skill", newskill);
  
          await axios.post("LearnerProfile/fetchjobOpportunities", formData)
  
          .then(res => {
              // console.log("res  ====")
             if(res.data.status === "200" || res.data.status === "100"){
              if(res.data.joblst){}
              setJoblst(res.data.joblst);
              setLocation(res.data.location);
              setLoading(false);
              setShowComponent(true);
             }
             else{
             
              toast.error("Something went wrong")
             }
          })
  
      }
      
   }

   if (!context.user?.email) {
    return <Redirect to="/" />;
  }
    return (
      <div>
      <br />
      <br />
      <br />
      <br />
      <section class=" padding-default">
        <div class="panel panel-primary card">
          <div class="panel-heading"> Job Search Details </div>

          <div class="panel-body">
            <div class="row ">
              <div class="col-md-12">
                <form >
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-6">
                        <label>
                          {" "}
                          <b>Location </b>
                        </label>
                        {/* <input
                          placeholder="provide your Name"
                          class="form-control"
                          type="text"
                          //value={name}
                          // id="location"
                          id="pac-input"
                          name="location"
                          onChange={(e) => setNewlocation(e.target.value)}
                        
                        /> */}

{/* <input ref={autocompleteInput}  id="autocomplete"   name="location"  placeholder="Enter your Location"
         type="text"></input> */}

<div >
      <PlacesAutocomplete
      value={address}
      onChange={handleChange}
      //onSelect={this.handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <input
            {...getInputProps({
              placeholder: 'Enter your Location ...',
              className: 'location-search-input',
            })}
          />
          <div className="autocomplete-dropdown-container">
            {loading && <div>Loading...</div>}
            {suggestions.map(suggestion => {
              
              // inline style for demonstration purpose
              const style = suggestion.active
                ? { backgroundColor: '#42a5f5', cursor: 'pointer' }
                : { backgroundColor: '#ffffff', cursor: 'pointer' };
              return (
                <div className="input-suggestion"
                  {...getSuggestionItemProps(suggestion, {
                    
                    style,
                  })}
                >
                <i class="material-icons">location_on  </i> <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
      </div>
                      </div>

                      <div class="col-md-4">
                        <label>
                          <b>Skill</b>
                        </label>
                        <select
                          class="form-control"
                          required
                          name="skill"
                          id="skill"
                          onChange={(e) => setNewskill(e.target.value)}
                         
                        >
                            <option value="null">
                               Select Your  Skill
                            </option>
                          {skilllist.map((option) => (
                            <option value={option.skillname}>
                              {option.skillname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <br />
                    <br />
                   
                    <div className="col-lg-12 text-center">
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  onClick={(e) =>
                    handleSubmit( e )
                  }
                >
                 Show Jobs
                </Button>

                {loading === true ? (
                  <CircularProgress
                    size={24}
                    color="green"
                    className="buttonProgress1"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    
      {showComponent === true ? (
        <>
          <br />
          
          <div class="padding-default">
            <h4>
              {" "}
              Recommended Jobs as per your skills in{" "}
              <FontAwesomeIcon icon={faMapMarkerAlt} /> {location}
            </h4>
            <br />
            <div class="row ">
              {joblst.map((item) => (
                <div class=" col-md-6 col-sm-8 col-lg-4 ">
                  <div class="card text-center card-fix-height">
                    <br />
                    <center>
                      <h5>
                        <b>{item[2]}</b>{" "}
                      </h5>
                      <br />
                      <h6>
                        <b> {item[1]}</b>
                      </h6>
                      <br />
                      <p>
                        {" "}
                        <i class="fa  fa-map-marker"> </i> {item[7]}{" "}
                      </p>
                      <br />
                      <p>{item[5]} </p>
                      <hr />
                      <br />
                      <a href={item[0]} target="_blank" rel="noreferrer">
                        <input
                          type="button"
                          class="btn_1 rounded"
                          value="Learn More & Apply"
                        />
                      </a>
                      <br /> <br />
                    </center>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      <br />
      <br />
      {/* <section class=" padding-default">
        <div class="panel panel-primary card">
          <div class="panel-heading">Job By Career-Jet API</div>

          <div class="panel-body">
            <div class="row ">
              <div class="col-md-12">
               
                  
                  <Anchor name="cjsearchboxanchor"></Anchor>
<div class="cjsearchbox"> */}
    {/* <script language="javascript" type="text/javascript" src="http://www.careerjet.de/partners/js_searchbox.html?n=7&nfr=1"></script> */}
    {/* <Helmet>
      
    <script src="http://www.careerjet.de/partners/js_searchbox.html?n=7&nfr=1" type="text/javascript" />
</Helmet> */}
{/*    
    <div class="cjbotl bloggerDiv"></div>
</div> */}


               
              {/* </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
    );
  };


  


export default Opportunities;
